// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button--2CdnF","Button--grey":"Button--grey--297Np","Button--small":"Button--small--xNyFz"};